import { IStockTakeItemDetail } from '../models';
import { IconsEnum } from '../../../shared-modules/shared-icons/models/icons.enum';

/**
 * Whether this stock take line has a barcode change pending until process.
 */
export function hasPendingBarcodeUpdate(item: Pick<IStockTakeItemDetail, 'pendingBarcodeUpdate'>): boolean {
  return !!item.pendingBarcodeUpdate?.scannedBarcode?.trim();
}

export const stockTakePendingBarcodeTooltip = 'Barcode will be updated when this stock take is processed';

export const stockTakeUniqueItemTooltip = 'Unique scan — item was not on the original stock take list';

export const stockTakePendingBarcodeIcon = IconsEnum.barcodeScan;

export const stockTakeUniqueItemIcon = IconsEnum.tagMultiple;
